import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import {
  FormDialogActions,
} from '@marageti/z4-lib';

type TicketDeleteModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

const TicketDeleteModal = ({
  open,
  onClose,
  onConfirm,
}: TicketDeleteModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Delete Ticket?</DialogTitle>
      <DialogContent sx={{ paddingTop: 0.5 }}>
        <Typography variant="body" color="text.secondary">
          This action cannot be undone. All data, internal notes, and
          history associated with this ticket will be permanently removed.
        </Typography>
      </DialogContent>

      <FormDialogActions sx={{ mt: 0, border: 0, p: 4 }}>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isSubmitting}
          onClick={handleConfirm}
        >
          Delete
        </LoadingButton>
        <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
      </FormDialogActions>
    </Dialog>
  );
};

export default TicketDeleteModal;
